import { render, staticRenderFns } from "./LamboPreOwnedColumn2.vue?vue&type=template&id=5e58b194&scoped=true&"
import script from "./LamboPreOwnedColumn2.vue?vue&type=script&lang=js&"
export * from "./LamboPreOwnedColumn2.vue?vue&type=script&lang=js&"
import style0 from "./LamboPreOwnedColumn2.vue?vue&type=style&index=0&id=5e58b194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e58b194",
  null
  
)

export default component.exports